import script from "./AdminMainView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminMainView.vue?vue&type=script&setup=true&lang=js"

import "./AdminMainView.vue?vue&type=style&index=0&id=b7d0cbba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7d0cbba"]])

export default __exports__